/**
 * Learner enrollment read (Phase SC-5).
 *
 * `GET /api/me/enrollment` is the tenant-scoped identity for a study-centre
 * learner: which roster row they belong to and whether intake is still
 * required at *this* centre (same email at SC-B starts fresh).
 */

import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { api } from "../api";

export interface MyEnrollment {
  id: string;
  tenant_id: string;
  student_id: string;
  student_name: string;
  status: string;
  enrolled_at: string;
  pathway_count: number;
  needs_intake: boolean;
  app_access_granted: boolean;
  needs_app_payment: boolean;
  app_access_paid_until: string | null;
  learner_app_pricing_mode: string | null;
  learner_app_monthly_price_paise: number | null;
}

const MY_ENROLLMENT_KEY = ["my-enrollment"] as const;

export function useMyEnrollment(enabled = true): UseQueryResult<MyEnrollment> {
  return useQuery<MyEnrollment>({
    queryKey: MY_ENROLLMENT_KEY,
    queryFn: () => api.get<MyEnrollment>("/api/me/enrollment"),
    enabled,
    retry: false,
  });
}

export { MY_ENROLLMENT_KEY };
